export default __webpack_public_path__ + "static/media/Me2.561b95ca.png";